import { getLaxhjalpenStudentList } from '../Services/laxhjalpenStudentList';
import { useBizQuery } from './useBizQuery';

export const LAXHJALPEN_STUDENT_LIST_QUERY_KEY = 'LAXHJALPEN_STUDENT_LIST';

export function useLaxhjalpenStudentList(unitId: number, enabled = true) {
	return useBizQuery(
		[LAXHJALPEN_STUDENT_LIST_QUERY_KEY, unitId],
		() => (unitId > 0 ? getLaxhjalpenStudentList(unitId) : Promise.resolve([])),
		enabled && unitId > 0,
		0,
		'always',
		false
	);
}
